import datapoints from '../datapoints';
import mapInboxRuleToInboxRuleClauses from './helpers/mapInboxRuleToInboxRuleClauses';
import { InboxRulesEditOptionState } from '../store/schema/InboxRulesEditOptionState';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { logUsage } from 'owa-analytics';

export interface EditInboxRuleOptionState {
    listOptionState: InboxRulesListOptionState;
    editOptionState: InboxRulesEditOptionState;
}
/**
 * Sets the given rule to edit mode
 * @param inboxRuleId the inbox rule id
 */
export default select<EditInboxRuleOptionState>({
    listOptionState: () => store.inboxRulesListState,
    editOptionState: () => store.inboxRulesEditState,
})(
    action('editInboxRule')(function editInboxRule(
        inboxRuleId: string,
        state?: EditInboxRuleOptionState
    ) {
        const {
            name: eventName,
            customData: customData,
        } = datapoints.editInboxRuleDatapoint.datapoint;

        let { listOptionState } = state;
        let inboxRule = listOptionState.inboxRules.get(inboxRuleId);
        logUsage(eventName, customData(inboxRule));
        mapInboxRuleToInboxRuleClauses(inboxRule);
    })
);
